import React from 'react';
import { useSelector } from 'react-redux';
import { Pane, PaneProps } from 'evergreen-ui';
import { datasourceSelector, datasourceTypeSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { useIsStationAdmin } from 'Features/StationsNew/Hooks';
import { useGeneralStationsStyles } from 'Features/StationsNew/useStyles';
import DatasourceMenu from './DatasourceMenu';
import DatasourceName from './DatasourceName';
import { DatasourceIconControls } from './DatasourceIconControls';
import DatasourceStatuses from './DatasourceStatuses';
import { ExtendedDatasourceType, getExtendedDatasource } from './utils';

type DatasourceNavigationRowProps = PaneProps & {
  stationId: number,
  datasourceId: number,
  className?: string,
  isExpanded?: boolean,
  withoutMenu?: boolean,
}

export const DatasourceNavigationRow = ({
  className = '',
  stationId,
  datasourceId,
  isExpanded = false,
  withoutMenu = false,
  ...props
}: DatasourceNavigationRowProps) => {
  const classes = useGeneralStationsStyles();
  const datasource = useSelector(datasourceSelector(datasourceId));
  const datasourceType = useSelector(datasourceTypeSelector(datasource.datasourceTypeId));
  const isStationAdmin = useIsStationAdmin(stationId);

  const extendedDatasource: ExtendedDatasourceType = React.useMemo(
    () => getExtendedDatasource(datasource, datasourceType),
    [datasource, datasourceType],
  );

  return (
    <Pane className={`${classes.pageNavigationRow} ${className}`} {...props}>
      <DatasourceStatuses datasourceId={datasourceId} />
      <DatasourceName datasource={extendedDatasource} />
      <DatasourceIconControls
        flexGrow={1}
        stationId={stationId}
        datasourceId={datasourceId}
        datasourceName={extendedDatasource.datasourceTypeShortName}
        isExpanded={isExpanded}
      />
      {
        !withoutMenu
          ? (
            <DatasourceMenu
              stationId={stationId}
              datasource={extendedDatasource}
              isStationAdmin={isStationAdmin}
            />
          )
          : null
      }
    </Pane>
  );
};
export const MemoDatasourceNavigationRow = React.memo(DatasourceNavigationRow);
MemoDatasourceNavigationRow.displayName = 'MemoDatasourceNavigationRow';
export default DatasourceNavigationRow;
